// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__c1SnX","colMaxWidth":"Table_colMaxWidth__1bBCy"};